import { ScreenTemplate } from '@components-fabric/types';
import { findFirstValueDefined } from '@dirootie-toolbox/objects';

export const getLabel = (obj: ScreenTemplate) => {
  const result = findFirstValueDefined<string>([
    "label",
    "title",
    "breadcrumb",
    "section.title",
    "section.breadcrumb",
    "id",
    "section.id"
  ],obj,"NOT_SET");
  return result;
}
